<div class="mt-shell" [class.dark]="isDark">
  <ngx-loading [show]="isLoading"></ngx-loading>

  <!-- ══ HUD BAR ══ -->
  <div class="mt-hud">
    <div class="mt-hud__left">
      <div class="mt-hud__icon-wrap">
        <mat-icon>shield</mat-icon>
      </div>
      <div class="mt-hud__title-block">
        <span class="mt-hud__eyebrow">ADMIN CONSOLE</span>
        <span class="mt-hud__title">{{ 'ADMIN_MANAGE_TEAM.TITLE' | translate }}</span>
      </div>
    </div>

    <div class="mt-hud__right">
      <button class="mt-btn mt-btn--primary" type="button" (click)="onAddTeam()">
        <mat-icon>add</mat-icon>
        <span>{{ 'ADMIN_MANAGE_TEAM.ADD_BUTTON_TEXT' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- ══ GRID ══ -->
  <div class="mt-grid-wrap">

    <!-- empty state -->
    <div class="mt-empty" *ngIf="!isLoading && teams.length === 0">
      <div class="mt-empty__icon-wrap">
        <mat-icon>group_off</mat-icon>
      </div>
      <span class="mt-empty__label">NO SQUADS FOUND</span>
      <span class="mt-empty__sub">Create your first squad to get started</span>
    </div>

    <!-- team cards -->
    <div class="row g-3 g-xl-4">
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3"
           *ngFor="let team of teams; let i = index; trackBy: trackTeam">

        <div class="mt-card">
          <!-- top bar -->
          <div class="mt-card__bar"></div>
          <!-- corner notch -->
          <div class="mt-card__notch"></div>
          <!-- scanlines -->
          <div class="mt-card__scanlines"></div>

          <!-- icon + name -->
          <div class="mt-card__hero">
            <div class="mt-card__icon-ring">
              <app-s3-image [image]="team.icon"></app-s3-image>
            </div>
            <div class="mt-card__name-block">
              <span class="mt-card__name">{{ team.name }}</span>
              <span class="mt-card__desc">{{ team.description }}</span>
            </div>
          </div>

          <!-- divider -->
          <div class="mt-card__divider"></div>

          <!-- stats row -->
          <div class="mt-card__stats">
            <div class="mt-stat">
              <span class="mt-stat__val">{{ team.members.length }}</span>
              <span class="mt-stat__label">
                {{ team.members.length === 1
                  ? ('ADMIN_MANAGE_TEAM.MEMBERS.MEMBERS_SINGLE' | translate)
                  : ('ADMIN_MANAGE_TEAM.MEMBERS.MEMBERS_MULTI' | translate) }}
              </span>
            </div>
            <div class="mt-stat mt-stat--lead">
              <div class="mt-stat__avatar">
                <app-s3-image [isRounded]="true" [image]="team.teamLead.avatarUrl"></app-s3-image>
              </div>
              <div class="mt-stat__lead-info">
                <span class="mt-stat__lead-label">LEAD</span>
                <span class="mt-stat__lead-name">{{ team.teamLead.username }}</span>
              </div>
            </div>
          </div>

          <!-- action overlay -->
          <div class="mt-card__overlay">
            <button class="mt-action-btn mt-action-btn--edit" type="button"
                    (click)="onEditTeam(team)" title="Edit squad">
              <mat-icon>edit</mat-icon>
              <span>EDIT</span>
            </button>
            <button class="mt-action-btn mt-action-btn--delete" type="button"
                    (click)="onDeleteTeam(team)" title="Delete squad">
              <mat-icon>delete_outline</mat-icon>
              <span>DELETE</span>
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- load more -->
    <div class="mt-load-more" *ngIf="nextToken">
      <button class="mt-btn mt-btn--ghost" type="button" (click)="loadMoreTeams()">
        <mat-icon>expand_more</mat-icon>
        <span>{{ 'BUTTON.LOAD_MORE' | translate }}</span>
      </button>
    </div>

    <!-- error -->
    <div class="mt-error-banner" *ngIf="errorMessage">
      <mat-icon>warning_amber</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

  </div>
</div>
